'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentUploadStart = undefined;

var _reduxActions = require('redux-actions');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var attachmentUploadStart = exports.attachmentUploadStart = (0, _reduxActions.createAction)(_fileUploadsActionTypes.ATTACHMENT_UPLOAD_START);


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/attachmentUploadStart.js
// module id = 560
// module chunks = 2 3